import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Connections from "@/pages/Connections";
import Repositories from "@/pages/Repositories";
import PipelineBuilder from "@/pages/PipelineBuilder";
import Pipelines from "@/pages/Pipelines";
import PipelineDetail from "@/pages/PipelineDetail";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center bg-void text-acid font-mono text-sm">&gt; autenticando_</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-void" />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { borderRadius: 0, border: "1px solid #27272A", background: "#0F0F11", fontFamily: "JetBrains Mono" } }} />
          <Routes>
            <Route path="/" element={<Navigate to="/app" replace />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/connections" element={<Protected><Connections /></Protected>} />
            <Route path="/app/repositories" element={<Protected><Repositories /></Protected>} />
            <Route path="/app/build" element={<Protected><PipelineBuilder /></Protected>} />
            <Route path="/app/pipelines" element={<Protected><Pipelines /></Protected>} />
            <Route path="/app/pipelines/:id" element={<Protected><PipelineDetail /></Protected>} />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
